export const Sponsors = {
  JT: "Cruyff",
  WCT: "Cruyff"
};
